export async function login(usuario, contrasenia) {
  try {
    const { code, body } = await fetch(
      "https://gestiondeflota.boltrack.net/despachoapi/api/autenticacion/login",
      {
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({ usuario, contrasenia }),
      }
    ).then((res) => res.json());
    return { code, body };
  } catch (err) {
    console.log("login err");
    console.log(err);
    return [];
  }
}
